import React from "react";
//#region types
import { ActionLinksGroupButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ActionLinksGroupButton: React.FC<ActionLinksGroupButtonProps> = ({ button, index }) => {
  return (
    <ActionLinkButton
      key={index}
      startIcon={<Icon icon={button.icon} />}
      onClick={button.onClickHandler}
      className={cssExports.actionLinkButton}
    >
      {button.btnText}
    </ActionLinkButton>
  );
};

export default ActionLinksGroupButton;
